import immutable from 'object-path-immutable';

import * as types from '../constants/actionTypes';

export const defaultState = {
  ratingType: '',
  submitDisabled: true,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.SET_RATING_TYPE:
      return immutable.set(state, 'ratingType', action.ratingType);

    case types.ENABLE_SUBMIT:
      return immutable.set(state, 'submitDisabled', false);

    case types.DISABLE_SUBMIT:
      return immutable.set(state, 'submitDisabled', true);

    default:
      return state;
  }
};
